export default __webpack_public_path__ + "static/media/grafema_clivitalbio_10.b2c908cd.jpg";